<template>
  <v-card
      flat
      rounded="0"
      class="mx-auto mb-8"
      max-width="1000"
      mim-width="350"
  >
    <v-carousel
        v-model="model"
        cycle
        height="150"
        hide-delimiter-background
        color="primary"
        :show-arrows="false">
      <v-carousel-item
          eager
          v-for="item in items"
          :src="getRealImgPath(item.src)"
          cover>
      </v-carousel-item>
    </v-carousel>

    <v-card class="mt-2 pl-3 pr-3" rounded="0" flat>
      <v-card-title class="pl-0 pr-0 font-weight-bold">이벤트/공지사항</v-card-title>
      <v-table density="compact">
        <thead>
        <tr class="bg-primary">
          <th class="text-white text-center">제목</th>
          <th class="text-white text-center">등록일</th>
        </tr>
        </thead>
        <tbody>
        <tr
            v-for="item in board"
            :key="item.title"
            class="text-center"
            @click="showDialog(item.seq_no)"
        >
          <td>{{ item.title }}</td>
          <td>{{ item.ins_date }}</td>
        </tr>
        </tbody>
      </v-table>

      <v-dialog
          max-width="1200"
          mim-width="350"
          v-model="dialog"
          transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar
              density="compact" color="white">
            <v-spacer></v-spacer>
            <v-btn icon @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <div class="pa-2 pt-0">
            <div class="editorHtml" v-html="comment"></div>
          </div>
        </v-card>
      </v-dialog>
    </v-card>
<!--    <v-card v-if="isAuth" class="mt-2 pl-3 pr-3" rounded="0" flat>-->
<!--      <v-card-title class="pl-0 pr-0 font-weight-bold">예약/구매/주문 현황</v-card-title>-->
<!--      <v-table density="compact">-->
<!--        <thead>-->
<!--        <tr class="bg-primary">-->
<!--          <th class="text-white text-center">회원권</th>-->
<!--          <th class="text-white text-center">예약</th>-->
<!--          <th class="text-white text-center">티켓</th>-->
<!--          <th class="text-white text-center">주문</th>-->
<!--        </tr>-->
<!--        </thead>-->
<!--        <tbody>-->
<!--        <tr class="font-weight-bold text-center">-->
<!--          <td>{{ status.membership }}</td>-->
<!--          <td>{{ status.reservation }}</td>-->
<!--          <td>{{ status.ticket }}</td>-->
<!--          <td>{{ status.order }}</td>-->
<!--        </tr>-->
<!--        </tbody>-->
<!--      </v-table>-->
<!--    </v-card>-->
<!--    <v-card v-else class="mt-2" flat>-->
<!--      <v-card-title class="font-weight-bold">예약/구매/주문 현황</v-card-title>-->
<!--      <v-card-text class="mt-2 text-body-1 text-center">간편인증이 필요한 정보입니다.</v-card-text>-->
<!--      <v-card-text class="pt-0 text-center">-->
<!--        <v-btn color="primary" to="/login" variant="tonal">간편인증</v-btn>-->
<!--      </v-card-text>-->
<!--    </v-card>-->
  </v-card>

  <MobileFooter></MobileFooter>
</template>

<script>
import MobileFooter from "@/components/common/MobileFooter";
import {main} from "@/api";
import authStore from '@/store/auth'
import commonStore from '@/store/common'
import shotUrlStore from "@/store/shotUrl";

export default {
  name: "Home",
  components: {MobileFooter},
  data() {
    return {
      items: [],
      board: [],
      status: {
        membership: 0,
        reservation: 0,
        ticket: 0,
        order: 0
      },
      isAuth: false,
      dialog: false,
      comment: "",
      model: 0,
    }
  },
  created() {
    //root 페이지에 corp 파라미터를 포함한 요청 발생 시, gilchkin으로 이동
    const corpParam = this.$route.query.corp;
    if (corpParam) {
      window.location.href = process.env.VUE_APP_ROOM_SERVER_URL + `?corp=${corpParam}`;
    }

    shotUrlStore.dispatch('removeRouterInfo')
    this.isAuth = authStore.state.authInfo.token !== null
    this.getBannerList(commonStore.state.common.corpCode)
    this.getNoticeList(commonStore.state.common.corpCode)
  },
  computed: {
    isAuth() {
      if (authStore.state.authInfo.token !== null) {
        this.getUserSummary()
        return true
      }
      return false
    },
  },
  methods: {
    getBannerList() {
      main.getNoticeList(commonStore.state.common.corpCode, 'banner')
          .then(data => {
            console.log(data)
            if (data.data.notices) {
              let array
              if (data.data.notices.length > 3) {
                array = data.data.notices.slice(0, 3)
              } else {
                array = data.data.notices
              }

              array.forEach((item) => {
                this.items.push({
                  src: item.thumb_url
                })
              })
            }
          })
          .catch(err => {
            console.log(err)
            if (err.isAlert) {
              alert(err.result.error_message)
            }
          })
    },
    getNoticeList() {
      main.getNoticeList(commonStore.state.common.corpCode, 'notice')
          .then(data => {
            console.log(data)
            if (data.data.notices) {
              let array
              if (data.data.notices.length > 3) {
                array = data.data.notices.slice(0, 3)
              } else {
                array = data.data.notices
              }

              this.board = array
            }
          })
          .catch(err => {
            console.log(err)
            if (err.isAlert) {
              alert(err.result.error_message)
            }
          })
    },
    getUserSummary() {
      main.getUserSummary(commonStore.state.common.corp, commonStore.state.common.corpCode)
          .then(data => {
            console.log(data)
            this.status = {
              membership: 0, // TODO
              reservation: data.data.rsrv_cnt,
              ticket: data.data.tkt_cnt,
              order: data.data.order_cnt
            }
          })
          .catch(err => {
            console.log(err)
            if (err.isAlert) {
              alert(err.result.error_message)
            }
          })
    },
    showDialog(id) {
      this.dialog = true
      this.comment = this.board.find(v => v.seq_no === id).comment
      this.modifyImgStyles()
    },
    modifyImgStyles() {
      this.$nextTick(() => {
        const imgTags = document.querySelectorAll('.editorHtml img');
        imgTags.forEach((img) => {
          img.style.width = '90%';
        });
      });
    },
  }
}
</script>

<style>
.html_content > img { width: 100% }
</style>